module.exports = __webpack_public_path__ + "img/logo_color.bece0681.png";